export default __webpack_public_path__ + "static/media/fail.ba6224c5.svg";